import { render } from "./CategoryTestsDetails.vue?vue&type=template&id=631034aa"
import script from "./CategoryTestsDetails.vue?vue&type=script&lang=js"
export * from "./CategoryTestsDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__